module.exports = __webpack_public_path__ + "static/Juxtapose-Quote-Machine-9a49c6e2f163f30b59524e234d2537cf.png";